
export type CreateNotificationBodyType = typeof CreateNotificationBodyType[keyof typeof CreateNotificationBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationBodyType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
